import { ArticleEvent, Milestone } from 'models/shipments';

import { useCurrentArticle } from '../../hooks/shipment.hooks';

export interface MilestoneEventGroup {
  milestone: string;
  events?: ArticleEvent[];
}

const PENDING_MILESTONE_GROUP = { milestone: Milestone.PENDING };

export const useJourneyMilestones = (): MilestoneEventGroup[] => {
  const articleEvents = useCurrentArticle()?.events || [];

  if (articleEvents.length === 0) return [PENDING_MILESTONE_GROUP];
  const milestoneGroups: MilestoneEventGroup[] = [];
  let currentGroup: MilestoneEventGroup;
  articleEvents.forEach((event) => {
    if (!event.milestone) return;
    if (event.milestone !== currentGroup?.milestone) {
      currentGroup = {
        milestone: event.milestone,
        events: [event],
      };
      milestoneGroups.unshift(currentGroup);
    } else {
      currentGroup?.events?.unshift(event);
    }
  });

  return milestoneGroups;
};
